import { queryIframeContent } from '@utils/query';

export const getElementByXPath = (originXpath) => {
	try {
		const xpath = originXpath.replace('svg', "*[name()='svg']");
		const doc = queryIframeContent();

		return doc.evaluate(
			xpath,
			doc,
			null,
			XPathResult.FIRST_ORDERED_NODE_TYPE,
			null,
		).singleNodeValue;
	} catch (e) {
		console.error(e);
		return null;
	}
};
